import {
    CablingManifestTabTableByCablingStatus
} from "../cablingManifest/interface/CablingManifestTabTableByCablingStatus";
import {CABLING_MANIFEST_TABLE_CONSTANT} from "../LmdpConstants";
import {AggregateCablingManifestBySite} from "../plannedDeliveries/interface/AggregateCablingManifestBySite";
import {CablingStatusWiseItemsCount} from "../cablingManifest/interface/CablingStatusWiseItemsCount";

export function getItemByCablingStatus(items: AggregateCablingManifestBySite[], cablingStatus: string, statusCount: (count: CablingStatusWiseItemsCount) => void): readonly CablingManifestTabTableByCablingStatus[] {
    const cablingCompletedItems = items.map(item => {
        return {
            site: item.site,
            weekWiseCount: [0, 1, 2].map(index => (item.aggregatedCablingStatus?.[index]?.cablingDone) ?? 0),
            totalCount: item.aggregatedCablingStatus.reduce((total, status) => total + status.cablingDone, 0)
        };
    }).filter(item => item.totalCount !== 0);

    const cablingInProgressItems = items.map(item => {
        return {
            site: item.site,
            weekWiseCount: [0, 1, 2].map(index => (item.aggregatedCablingStatus?.[index]?.cablingInProgress) ?? 0),
            totalCount: item.aggregatedCablingStatus.reduce((total, status) => total + status.cablingInProgress, 0)
        };
    }).filter(item => item.totalCount !== 0);

    const notCabledItems: CablingManifestTabTableByCablingStatus[] = items.map(item => {
        return {
            site: item.site,
            weekWiseCount: [0, 1, 2].map(index => (item.aggregatedCablingStatus?.[index]?.cablingNotStarted) ?? 0),
            totalCount: item.aggregatedCablingStatus.reduce((total, status) => total + status.cablingNotStarted, 0)
        };
    }).filter(item => item.totalCount !== 0);

    statusCount({
        notCabledCount: notCabledItems.reduce((sum, notCabledItem) => sum + notCabledItem.totalCount, 0),
        cablingCompletedCount: cablingCompletedItems.reduce((sum, cablingCompletedItem) => sum + cablingCompletedItem.totalCount, 0),
        cablingInProgressCount: cablingInProgressItems.reduce((sum, cablingInProgressItem) => sum + cablingInProgressItem.totalCount, 0)
    });

    if (cablingStatus === CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TAB.CABLING_COMPLETED) {
        return cablingCompletedItems.slice().sort((start, end) => end.totalCount - start.totalCount);
    } else if (cablingStatus === CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TAB.CABLING_IN_PROGRESS) {
        return cablingInProgressItems.slice().sort((start, end) => end.totalCount - start.totalCount)
    } else {
        return notCabledItems.slice().sort((start, end) => end.totalCount - start.totalCount);
    }
}